import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {ClinicFilterService} from "../../state/clinic-filter/clinic-filter.service";

@Component({
    standalone: false,
    selector: 'app-categories-filter-modal',
    templateUrl: './categories-filter-modal.component.html',
    styleUrls: ['./categories-filter-modal.component.scss'],
})

export class CategoriesFilterModalComponent {
    @Input() availableTags: string[] = [];
    @Input() onClear?: () => void;
    searchText = '';
    stagedTags: string[];

    constructor(
        private modalController: ModalController,
        public clinicFilterService: ClinicFilterService
    ) {
        this.stagedTags = [...this.clinicFilterService.activeCategoryTags()];
    }

    toggleStagedTag(tag: string): void {
        if (this.stagedTags.includes(tag)) {
            this.stagedTags = this.stagedTags.filter((t) => t !== tag);
        } else {
            this.stagedTags = [...this.stagedTags, tag];
        }
    }

    close(): void {
        this.modalController.dismiss();
    }

    get hasNoChanges(): boolean {
        const activeCategoryTags = this.clinicFilterService.activeCategoryTags();
        return this.stagedTags.length === activeCategoryTags.length &&
            this.stagedTags.every((tag) => activeCategoryTags.includes(tag));
    }

    confirm(): void {
        if (this.hasNoChanges) return;
        this.clinicFilterService.setTags(this.stagedTags);
        this.modalController.dismiss({ confirmed: true});
    }

    clearFilters(): void {
        this.clinicFilterService.setCity(null);
        this.clinicFilterService.setTags([]);
        this.stagedTags = [];
        this.onClear?.();
    }

    private normalizeText(text: string): string {
        return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    filteredTags(): string[] {
        const normalizedSearch = this.normalizeText(this.searchText);
        return this.availableTags.filter(tag => this.normalizeText(tag).includes(normalizedSearch));
    }
}
